import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import Stack from "./stack.js";
import {fontFamily, lineHeight} from "./theme.js";
export default function Fieldset(props) {
  const {headline, children, ...rest} = props;
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Inner, null, headline && /* @__PURE__ */ React.createElement(Headline, null, headline), children));
}
const Container = styled.fieldset`
  * + & {
    margin-top: 8px;
  }
`;
const Headline = styled.legend`
  font-family: ${fontFamily.secondary};
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: ${lineHeight};
`;
const Inner = styled(Stack)``;
